import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * @deprecated Prefer the canonical `Spinner` from `@/components/glitch-ui/spinner`.
 *
 * Kept as a thin adapter (#5342) so the existing 38 call sites keep their
 * `{ show, wait, size, className }` API while rendering the standard `Loader2` icon (it used to be a
 * spinning `⍥` glyph). Colour is inherited from the parent (`currentColor`), matching the previous
 * behaviour inside coloured buttons; the `show`/`wait` delayed opacity fade is preserved.
 */
export function Spinner({
  show,
  wait,
  size,
  className,
}: {
  show?: boolean;
  wait?: `delay-${number}`;
  size?: string;
  className?: string;
}) {
  const sizeCls = size === 'lg' ? 'h-6 w-6' : size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return (
    <Loader2
      aria-hidden
      className={cn(
        'inline-block animate-spin transition-opacity duration-500',
        (show ?? true) ? cn('opacity-100', wait ?? 'delay-300') : 'opacity-0 delay-0',
        sizeCls,
        className,
      )}
    />
  );
}
